module.exports = __webpack_public_path__ + "img/caret-up.7bc0db72.svg";